/**
 * Release version reported to Datadog RUM & Logs.
 *
 * Injected at build time from the CI commit short SHA via webpack's
 * EnvironmentPlugin (see `webpack.common.js`). The variable must stay
 * whitelisted there — reading an un-whitelisted `process.env` value would
 * fall back to the DefinePlugin `process.env` object and leak the whole
 * environment into the bundle.
 *
 * Falls back to `local` outside CI.
 */
export const APP_VERSION = process.env.CI_COMMIT_SHORT_SHA || 'local';
